import { Check, XCircle } from "@phosphor-icons/react";

const STEPS = [
  { key: "eingegangen", label: "Eingegangen" },
  { key: "kontaktiert", label: "Kontaktiert" },
  { key: "gespraech", label: "Im Gespräch" },
  { key: "gestartet", label: "Gestartet" },
];

export function CareerTracker({ status }) {
  if (status === "kein_interesse") {
    return (
      <div className="flex items-center gap-2 rounded-lg bg-[#718096]/10 px-3 py-2 text-sm font-semibold text-[#718096]" data-testid="career-tracker">
        <XCircle size={16} weight="fill" /> Kein Interesse
      </div>
    );
  }
  const current = STEPS.findIndex((s) => s.key === status);
  return (
    <div className="flex flex-col" data-testid="career-tracker">
      {STEPS.map((step, i) => {
        const done = i <= current;
        const active = i === current;
        const isLast = i === STEPS.length - 1;
        const isStart = step.key === "gestartet" && done;
        return (
          <div key={step.key} className="flex gap-3">
            <div className="flex flex-col items-center">
              <div
                className={`flex h-7 w-7 items-center justify-center rounded-full border transition-colors duration-300 ${
                  isStart
                    ? "border-[#276749] bg-[#276749] text-white"
                    : done
                    ? "border-[#C5A059] bg-[#C5A059] text-white"
                    : "border-[#E2E8F0] bg-white text-transparent"
                }`}
              >
                {done ? <Check size={14} weight="bold" /> : <span className="h-1.5 w-1.5 rounded-full bg-[#CBD5E0]" />}
              </div>
              {!isLast && <div className={`w-px flex-1 min-h-[20px] ${i < current ? "bg-[#C5A059]" : "bg-[#E2E8F0]"}`} />}
            </div>
            <div className={`pb-3 pt-0.5 text-sm ${active ? "font-bold text-[#0A1128]" : done ? "font-semibold text-[#0A1128]" : "text-[#A0AEC0]"}`}>
              {step.label}
            </div>
          </div>
        );
      })}
    </div>
  );
}
